import {RequestResult, RequestResultValue} from "../../common/api/requestResult";
import {HttpService} from "../../common/api/httpService";
import {CommissionRule} from "../../models/commissionRule";
import {PaginationResponse} from "../../models/paginationResponse";
import JSONbig from "json-bigint";

const JSONbigNative = JSONbig({ useNativeBigInt: true });

export async function commissionRulesListApi(gameId: number, active: number, page: number, count: number)
    : Promise<RequestResultValue<PaginationResponse<CommissionRule>>> {
    const response = await HttpService.getInstance().requestPostAsync(`admin/commissionRules`, JSONbig.stringify({
        gameId: gameId === -1 ? undefined : gameId,
        active: active === -1 ? undefined : active === 1,
        page: page,
        count: count
    }));
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<PaginationResponse<CommissionRule>>(true, body as PaginationResponse<CommissionRule>);
    }
    return new RequestResultValue<PaginationResponse<CommissionRule>>(false);
}

export async function commissionRulesDeleteApi(id: number): Promise<RequestResult> {
    let url = `admin/commissionRules/${id}`;
    const response = await HttpService.getInstance().requestDeleteAsync(url);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResult(true);
    }
    return new RequestResult(false);
}

export async function commissionRulesAddApi(gameId: number, minAmountExclusive: bigint, maxAmountInclusive: bigint,
    fixedRate: bigint, percentRate: number, disabled: boolean) : Promise<RequestResultValue<CommissionRule>> {
    const response = await HttpService.getInstance().requestPostAsync(`admin/commissionRules/add`, JSONbig.stringify({
        gameId: gameId > 0 ? gameId : undefined,
        minAmountExclusive: minAmountExclusive,
        maxAmountInclusive: maxAmountInclusive > 0 ? maxAmountInclusive : undefined,
        fixedRate: fixedRate >= 0 ? fixedRate : undefined,
        percentRate: percentRate >= 0 ? percentRate : undefined,
        disabled: disabled
    }));
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<CommissionRule>(true, body as CommissionRule);
    }
    return new RequestResultValue<CommissionRule>(false);
}

export async function commissionRulesUpdateApi(id: number, gameId: number, minAmountExclusive: bigint, maxAmountInclusive: bigint,
    fixedRate: bigint, percentRate: number, disabled: boolean) : Promise<RequestResult> {
    let url = `admin/commissionRules/${id}`;
    const response = await HttpService.getInstance().requestPutAsync(url, JSONbig.stringify({
        gameId: gameId > 0 ? gameId : undefined,
        minAmountExclusive: minAmountExclusive,
        maxAmountInclusive: maxAmountInclusive > 0 ? maxAmountInclusive : undefined,
        fixedRate: fixedRate >= 0 ? fixedRate : undefined,
        percentRate: percentRate >= 0 ? percentRate : undefined,
        disabled: disabled
    }));
    if (response.status >= 200 && response.status < 300) {
        return new RequestResult(true);
    }
    return new RequestResult(false);
}